module.exports = __webpack_public_path__ + "static/media/elderly-man.5187df5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/bridging-the-gap/elderly-man.png
// module id = 356
// module chunks = 0